function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 11.25h-9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9c.41 0 .75.34.75.75s-.34.75-.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.82 11.25c-.24 0-.47-.11-.61-.32l-2.82-4a.74.74 0 01.18-1.04.74.74 0 011.04.18l2.82 4c.24.34.16.81-.18 1.04-.13.1-.28.14-.43.14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 11.25c-.15 0-.3-.04-.43-.14a.743.743 0 01-.18-1.04l2.82-4c.24-.34.71-.42 1.04-.18.34.24.42.71.18 1.04l-2.82 4c-.14.21-.38.32-.61.32zm4.5 3h-9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9c.41 0 .75.34.75.75s-.34.75-.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 18.25c-.15 0-.3-.04-.43-.14a.743.743 0 01-.18-1.04l2.82-4c.24-.34.71-.42 1.04-.18.34.24.42.71.18 1.04l-2.82 4c-.14.21-.38.32-.61.32z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.82 18.25c-.24 0-.47-.11-.61-.32l-2.82-4a.74.74 0 01.18-1.04.74.74 0 011.04.18l2.82 4c.24.34.16.81-.18 1.04-.13.1-.28.14-.43.14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12S6.07 1.25 12 1.25 22.75 6.07 22.75 12 17.93 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"
})));